import { SVGProps } from 'react';

const HoverTabArrow = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="28"
      viewBox="0 0 21 28"
      fill="none"
      {...props}
    >
      <path
        d="M9 7.75C9 7.33579 9.33579 7 9.75 7V7C10.1642 7 10.5 7.33579 10.5 7.75V9.95C10.5 10.8025 10.5006 11.3967 10.5384 11.8593C10.5755 12.3132 10.6446 12.574 10.7452 12.7715C10.961 13.1948 11.3052 13.539 11.7285 13.7548C11.926 13.8554 12.1868 13.9245 12.6407 13.9616C13.1033 13.9994 13.6975 14 14.55 14H17.9393L16.2197 12.2803C15.9268 11.9874 15.9268 11.5126 16.2197 11.2197C16.5126 10.9268 16.9874 10.9268 17.2803 11.2197L20.2803 14.2197C20.5732 14.5126 20.5732 14.9874 20.2803 15.2803L17.2803 18.2803C16.9874 18.5732 16.5126 18.5732 16.2197 18.2803C15.9268 17.9874 15.9268 17.5126 16.2197 17.2197L17.9393 15.5H14.5179C13.705 15.5 13.0494 15.5 12.5185 15.4566C11.9719 15.412 11.4918 15.3176 11.0475 15.0913C10.3419 14.7317 9.76825 14.1581 9.40873 13.4525C9.18239 13.0082 9.08803 12.5281 9.04336 11.9815C8.99999 11.4506 8.99999 10.795 9 9.98212V7.75Z"
        fill="#CCCCCC"
      />
    </svg>
  );
};

export default HoverTabArrow;
